// Returns the explicit demo/public label when one exists while preserving the
// legacy registration-number presentation for ordinary event entries.
export const getEntryRegistrationLabel = (entry, fallback = "Entry") => {
  const explicitLabel = String(entry?.registrationLabel || "").trim();

  if (explicitLabel) return explicitLabel;

  if (entry?.demoSeed) {
    const displayNumber =
      Number(entry?.displayOrder) ||
      Number(String(entry?.regcnt || "").match(/(\d+)$/)?.[1]);

    if (displayNumber > 0) {
      return `Test Entry #${String(displayNumber).padStart(3, "0")}`;
    }
  }

  const registrationNumber = String(entry?.regcnt ?? "").trim();

  return registrationNumber ? `Entry #${registrationNumber}` : fallback;
};
